<template>
    <div v-if="!viewMode" class="fields-group">
        <p v-if="group.title">{{group.title}}</p>
        <field-wrapper v-for="(field, index) in group.fields"
                       :key="field.id"
                       :type="field.type"
                       :value="value[index]"
                       :id="field.id"
                       :options="field.options"
                       :required="field.required"
                       :label="field.text"
                       :clone="field.clone"
                       @input="handleInput($event, index)"
        >
        </field-wrapper>
    </div>
    <div v-else class="fields-group">
        <p v-if="group.title">{{group.title}}</p>
        <field-wrapper-disabled v-for="(field, index) in group.fields"
                       :key="field.id"
                       :type="field.type"
                       :value="value[index]"
                       :id="field.id"
                       :options="field.options"
                       :label="field.text">
        </field-wrapper-disabled>
    </div>
</template>

<script>

    import FieldWrapper from "./FieldWrapper";
    import FieldWrapperDisabled from "./FieldWrapperDisabled";

    export default {
        name: 'field-group',
        components: {FieldWrapperDisabled, FieldWrapper},
        props: {
            group: Object,
            value: Array,
            viewMode: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleInput(e, index) {
                let newVal = this.value;
                newVal[index] = e;
                this.$emit('input', newVal);
            },
        },
    }
</script>


<style scoped>

</style>
